import React from "react";

import { makeStyles } from "@material-ui/styles";
import Divider from "@material-ui/core/Divider";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import CardHeader from "../../../components/CardHeader";
import Table from "../../../components/Table";

import useDeepMemo from "../../../hooks/useDeepMemo";
import { getColumnsShadeSummary, getRowsShadeSummary } from "../cutPlanHelper";
import useSafeState from "../../../hooks/useSafeState";
import { OState } from "../../../utils/types";
import { MULTI_PART_MANUAL_PLAN } from "../../../constants";

const useStyles = makeStyles({
  nowrapTable: {
    whiteSpace: "pre"
  },
  expansionContent: {
    overflowX: "auto",
    flexDirection: "column",
    padding: 0
  }
});

const ShadeSummary = props => {
  const classes = useStyles();
  const { className, order, cutOrder, planTabIdx } = props;

  const [expanded, setExpanded] = useSafeState(false);
  const [colorIdx, setColorIdx] = useSafeState(0);

  const styleColorList = cutOrder?.styleColorList || [];
  const styleColor = styleColorList[colorIdx];
  const manualCutPlan = cutOrder?.orderConfig?.multiPartBundling === MULTI_PART_MANUAL_PLAN;

  const { columns, headerRows } = useDeepMemo(() => getColumnsShadeSummary(order, cutOrder), [order, cutOrder]);

  const rows = useDeepMemo(() => getRowsShadeSummary(order, cutOrder, planTabIdx, styleColor), [order, cutOrder, planTabIdx, styleColor]);

  if (cutOrder?.stateValue <= OState.MAIN_CUTPLAN_GENERATED.stateValue || manualCutPlan) {
    return <div />;
  }

  return (
    <Accordion className={className} expanded={expanded} onChange={(e, expanded) => setExpanded(expanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <CardHeader title="Shade Summary" style={{ margin: 0, padding: "0.5em" }} />
      </AccordionSummary>
      {/* <Divider /> */}
      <AccordionDetails className={classes.expansionContent}>
        <Divider />
        {styleColorList.length > 1 && (
          <Tabs value={colorIdx} onChange={(e, idx) => setColorIdx(idx)} variant="scrollable" scrollButtons="auto">
            {styleColorList.map((styleColor, idx) => (
              <Tab key={idx} label={styleColor} />
            ))}
          </Tabs>
        )}
        {styleColorList.length > 1 && <Divider />}
        <PerfectScrollbar>
          <Table
            classes={{ table: classes.nowrapTable }}
            columns={columns}
            headerRows={headerRows}
            rows={rows}
            headerCellStyle={column => ({
              borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
              borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
              backgroundColor: "#C6D0DA"
            })}
            cellStyle={({ column, record }) =>
              record.shade === "Total"
                ? {
                    fontWeight: "bold",
                    borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
                    borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined
                  }
                : {
                    borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
                    borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined
                  }
            }
          />
        </PerfectScrollbar>
      </AccordionDetails>
    </Accordion>
  );
};

export default ShadeSummary;
